jQuery(function($){
    $('.multiselect__trigger').on('click', function(e) {
        e.preventDefault();

        $(this).parent().find('.multiselect__dropdown').toggleClass('is-toggle');
    });

    $('.multiselect__dropdown input[type="checkbox"]').on('change', function(e) {
        e.preventDefault();

        let selectedValues = [],
            globalContainer = $(this).parents('.multiselect__wrapper');

        globalContainer.find('input[type="checkbox"]:checked').each(function(){
            selectedValues.push($(this).parent().find('.multiselect__label').text());
        });

        globalContainer.find('input[type="text"]').val(selectedValues.join(', '));
    });

    $(document).mouseup(function(e) {
        var container = $(".multiselect__dropdown.is-toggle");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('is-toggle');
        }
    });
});
